document.addEventListener('cart:updated', () => setTimeout(checkPreOrderStatus, 500));
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        handleInitialLoad();
    }, 500);
});

const preOrderGlobalText = document.querySelector('[data-pre-order-button-text]')?.textContent || 'Pre-order';

document.addEventListener('variant:change', (evt) => handleVariantChange(evt.detail.variant));

function getInitialVariant() {
    const variantElement = document.querySelector('[data-variant-infos]');
    if (!variantElement) {
        return null;
    }
    return variantElement.getAttribute('[data-variant-infos]');
}

function handleVariantChange(variant) {
    if (!variant || !variant.id) {
        return;
    }

    const selectedOption = getSelectedOption(variant.id);
    if (!selectedOption) {
        return;
    }

    const attributes = getVariantAttributes(selectedOption);

    if (isOutOfStock(attributes.inventoryQuantity)) {
        handleSoldOutVariant(attributes, selectedOption);
    } else {
        handleAvailableVariant(attributes, selectedOption);
    }
}

function getSelectedOption(variantId) {
    return document.querySelector(`[data-variant-infos="${variantId}"]`);
}

function getVariantAttributes(selectedOption) {
    return {
        reserveButton: selectedOption.getAttribute('data-variant-reserve-now') === 'true',
        notifyButton: selectedOption.getAttribute('data-variant-notify') === 'true',
        showMessageBox: selectedOption.getAttribute('data-show-message-box') === 'true',
        inventoryPolicy: selectedOption.getAttribute('data-variant-inventory-policy'),
        inventoryQuantity: parseInt(selectedOption.getAttribute('data-variant-inventory-quantity')),
        messageBox: selectedOption.getAttribute('data-variant-message-box') || ''
    };
}

function updateMessageBox(messageText, showMessageBox) {
    const messageBox = document.querySelector('[data-pdp-message-box]');
    if (showMessageBox && messageBox) {
        if (messageBox) {
            if (messageText) {
                messageBox.textContent = messageText;
                messageBox.classList.remove('hidden');
            } else {
                messageBox.textContent = '';
                messageBox.classList.add('hidden');
            }
        }
    } else {
        if (messageBox) {
            messageBox.classList.add('hidden');
        }
    }
}

function handleAvailableVariant(attrs, selectedOption) {
    updateVisibility({
        reserveBadge: false,
        paymentForm: true,
        quantitySelector: true,
        messageBox: false,
        soldOutButtons: true
    });

    updateMessageBox(attrs.messageBox, false);
    updateNotifyButton(attrs.notifyButton);

    if (attrs.reserveButton && attrs.inventoryPolicy === 'continue' && attrs.inventoryQuantity <= 0) {
        handleSoldOutVariant(attrs, selectedOption);
        return;
    }

    setAllButtonsAddToCart();
    setReserveLineItem(false);
}

function setAllButtonsAddToCart() {
    const buttons = document.querySelectorAll('[data-reserve-button]');
    buttons.forEach((button) => {
        setReserveButtonLabel(button, getDefaultButtonText(button));
    });
}

function handleSoldOutVariant(attrs, selectedOption) {
    updateReserveButton(attrs.reserveButton);

    if (attrs.reserveButton) {
        setReserveLineItem(true);
        hideFreeShippingMessage('hide');
    } else {
        setReserveLineItem(false);
        hideFreeShippingMessage('show');
    }

    updateNotifyButton(attrs.notifyButton);
    const showMessageBox = attrs.showMessageBox && attrs.messageBox.trim() !== '';
    updateVisibility({
        reserveBadge: attrs.reserveButton,
        paymentForm: false,
        quantitySelector: false,
        messageBox: showMessageBox,
        soldOutButtons: attrs.reserveButton
    });

    updateMessageBox(attrs.messageBox, showMessageBox);
}

function updateVisibility({ reserveBadge, paymentForm, quantitySelector, messageBox, soldOutButtons }) {
    toggleElementVisibility('[data-product-reserve-badge]', reserveBadge);
    toggleElementVisibility('[data-product-payment-form]', paymentForm);
    toggleElementVisibility('[data-product-quantity-selector]', quantitySelector);
    toggleElementVisibility('[data-pdp-message-box]', messageBox);
    if (soldOutButtons !== undefined) {
        toggleElementVisibility('[data-sold-out-buttons]', soldOutButtons);
    }
}

function toggleElementVisibility(selector, isVisible) {
    const element = document.querySelector(selector);
    if (element) {
        element.classList.toggle('hidden', !isVisible);
    }
}

function updateReserveButton(isReserve) {
    const reserveButton = document.querySelector('[data-reserve-button]');
    if (reserveButton) {
        setReserveButtonLabel(reserveButton, isReserve ? preOrderGlobalText : getDefaultButtonText(reserveButton));
    }
}

function getDefaultButtonText(button) {
    return button.querySelector('[data-add-to-cart-text]')?.dataset.defaultText || 'Add to cart';
}

function setReserveButtonLabel(button, text) {
    const label = button.querySelector('[data-add-to-cart-text]');

    if (label) {
        label.textContent = text;
        syncStoredButtonText(text);
        return;
    }

    button.textContent = text;
    syncStoredButtonText(text);
}

function syncStoredButtonText(text) {
    localStorage.setItem('button_text', text);
}

function updateRestockRocketVisibility(isNotifyVisible) {
    document.querySelectorAll('[data-restock-rocket-mount]').forEach((mount) => {
        mount.classList.toggle('hidden', !isNotifyVisible);
        mount.toggleAttribute('hidden', !isNotifyVisible);
    });

    const inlineWidget = document.getElementById('restock-rocket-inline-container');
    if (inlineWidget) {
        inlineWidget.classList.toggle('hidden', !isNotifyVisible);
        inlineWidget.toggleAttribute('hidden', !isNotifyVisible);
        inlineWidget.style.display = isNotifyVisible ? '' : 'none';
    }
}

function updateNotifyButton(isNotifyVisible) {
    updateRestockRocketVisibility(isNotifyVisible);

    const findNotifyButton = setInterval(() => {
        if (document.getElementById('SI_trigger')) {
            const siTrigger = document.getElementById('SI_trigger');
            if (siTrigger) {
                siTrigger.classList.toggle('hidden', !isNotifyVisible);
                document.querySelectorAll('.si-reset').forEach(el => el.classList.toggle('hidden', !isNotifyVisible));
            }
            clearInterval(findNotifyButton);
        }
    }, 200);
}

function checkPreOrderStatus() {
    const lineItemAttributes = document.querySelectorAll('.cart__item--properties span');
    const cartMessageBox = document.querySelector('[data-cart-message-box]');

    const hasPreOrder = Array.from(lineItemAttributes).some(item => item.textContent.trim() === 'Pre-order:');
    if (cartMessageBox) {
        cartMessageBox.classList.toggle('hidden', !hasPreOrder);
    }
}

function hideFreeShippingMessage(state) {
    const shipTimerDisplay = document.querySelector('.product-block--sales-point');
    if (shipTimerDisplay) {
        shipTimerDisplay.style.display = state === 'hide' ? 'none' : 'block';
    }
}

function setReserveLineItem(add) {
    setTimeout(() => {
        const reserveLineItem = document.getElementById('reserve-now-line-item');

        if (reserveLineItem) {
            reserveLineItem.remove();
        }

        if (add) {
            const reserveNowText = document.querySelector('[data-reserve-now-cart-text]')?.getAttribute('data-reserve-now-cart-text') || 'Reserve Now';
            const inputElement = document.createElement('input');
            inputElement.id = 'reserve-now-line-item';
            inputElement.type = 'text';
            inputElement.classList.add('hidden');
            inputElement.name = 'properties[Pre-order]';
            inputElement.value = reserveNowText;

            const targetDiv = document.querySelector('[data-sold-out-buttons]');
            if (targetDiv) {
                targetDiv.appendChild(inputElement);
            }
        }
    }, 200);
}

function handleInitialLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromURL = urlParams.get('variant');

    let variantId;

    if (variantIdFromURL) {
        variantId = variantIdFromURL;
    } else {
        const variantElement = document.querySelector('[data-variant-infos]');
        if (!variantElement) {
            return;
        }
        variantId = variantElement.getAttribute('data-variant-infos');
    }

    const selectedOption = document.querySelector(`[data-variant-infos="${variantId}"]`);
    if (!selectedOption) {
        return;
    }

    const attributes = getVariantAttributes(selectedOption);

    if (isOutOfStock(attributes.inventoryQuantity)) {
        handleSoldOutVariant(attributes, selectedOption);
    } else {
        handleAvailableVariant(attributes, selectedOption);
    }
}

function isOutOfStock(inventoryQuantity) {
    return inventoryQuantity <= 0;
}

let searchInterval = null;

function checkForGpoElement() {
    const gpoElement = document.querySelector('.gpo-element');
    if (gpoElement) {
        setTimeout(() => {
            localStorage.setItem('button_text', document.querySelector('[data-reserve-button]').textContent);
        }, 1000);

        clearInterval(searchInterval);

        document.addEventListener('click', (event) => {
            const target = event.target;
            const buttonText = localStorage.getItem('button_text');
            if (target.tagName.toLowerCase() === 'input') {
                setTimeout(() => {
                    const reserveButton = document.querySelector('[data-reserve-button]');
                    if (reserveButton) {
                        syncStoredButtonText(reserveButton.querySelector('[data-add-to-cart-text]')?.textContent || reserveButton.textContent);
                    }
                }, 200);

                const addToCartButton = document.querySelectorAll('[data-reserve-button]');
                addToCartButton.forEach((button) => {
                    if (button) {
                        setReserveButtonLabel(button, buttonText || getDefaultButtonText(button));
                    }
                });
            }
        });
    }
}

searchInterval = setInterval(() => {
    checkForGpoElement();
}, 200);

setTimeout(() => {
    if (searchInterval) {
        clearInterval(searchInterval);
    }
}, 5000);